// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zgXs0BhSDXPbK_ {
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: W7cejrvd9hCJPN;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  width: 100%;
  height: 36px;
  margin: var(--ds-space-100, 8px) var(--ds-space-0, 0);
}
@keyframes W7cejrvd9hCJPN {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .zgXs0BhSDXPbK_ {
    animation: none;
  }
}
.zgXs0BhSDXPbK_:last-child {
  margin-bottom: var(--ds-space-150, 12px);
}
.P78P0XAFIiETGE {
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: W7cejrvd9hCJPN;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  width: 100%;
  height: 32px;
  margin: var(--ds-space-150, 12px) var(--ds-space-0, 0) var(--ds-space-075, 6px);
}
@keyframes W7cejrvd9hCJPN {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .P78P0XAFIiETGE {
    animation: none;
  }
}
`, ""]);
// Exports
export var row = `zgXs0BhSDXPbK_`;
export var shimmer = `W7cejrvd9hCJPN`;
export var removeColorButton = `P78P0XAFIiETGE`;
export default ___CSS_LOADER_EXPORT___;
